import { FC } from "react";
import { Popup } from "../../ui-kit";

import { IUploadFile } from "./interface";

interface IModalPreview {
  file: IUploadFile;
  handleCancel: () => void;
  isShow: boolean;
}

import styles from "./UploadFile.module.scss";

const ModalItemPreview: FC<IModalPreview> = (props) => {
  const { isShow, file, handleCancel } = props;

  return (
    <Popup
      title={file.originalName || file.name || "Просмотр изображения"}
      open={isShow}
      onClose={handleCancel}
      footer={null}
    >
      <div class={styles.modalImg}><img src={file.thumbUrl} /></div>
    </Popup>
  );
};

export default ModalItemPreview;
